import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal, QRCode } from 'antd';
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';
import { LuDownload } from 'react-icons/lu';
import { RiInformationLine } from 'react-icons/ri';
import { BASE_URL } from '../constants/Url';
import { APP_ANDROID_APK_URL } from '../config/api';

function AndroidDownloadModal(props, ref) {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const showModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    const handleDownloadApk = () => {
        const a = document.createElement('a');
        a.href = APP_ANDROID_APK_URL;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.click();
    };

    const appStores = [
        { id: 'yingyongbao', nameKey: 'QQ应用宝', url:'https://a.app.qq.com/o/simple.jsp?pkgname=com.gobeta.estetica'},
        { id: 'oppo', nameKey: '360手机助手', url:"https://m.app.so.com/detail/index?id=4695742" },
        { id: 'xiaomi', nameKey: '小米应用商店', url: 'Please go to the Xiaomi App Store and search for “易皓” to download it' },
    ];

    return (
        <Modal
            centered
            open={open}
            onCancel={closeModal}
            footer={null}
            closeIcon={null}
            width={720}
            destroyOnClose={true}
            className="esi-android-modal"
            styles={{
                content: {
                    borderRadius: '24px',
                    padding: 0,
                    overflow: 'hidden',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                },
            }}
        >
            <div className="relative p-4 sm:p-8 md:p-10 bg-white text-gray-800 max-h-[90vh] overflow-y-auto">
                {/* Close Button */}
                <button
                    onClick={closeModal}
                    aria-label="Close"
                    className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full hover:bg-gray-100 focus:outline-none cursor-pointer z-10 flex items-center justify-center"
                >
                    <IoClose className="text-xl sm:text-2xl" />
                </button>

                {/* Header: Logo + Title + Subtitle */}
                <div className="flex items-center gap-3 sm:gap-5 pr-8 sm:pr-10">
                    <div className="w-14 h-14 sm:w-20 sm:h-20 shrink-0 flex items-center justify-center">
                        <img
                            src={BASE_URL + "/home/logoApp.png"}
                            alt="ESIPRO Logo"
                            className="w-full h-full object-contain"
                        />
                    </div>
                    <div className="flex flex-col text-left">
                        <h3 className="text-lg sm:text-2xl font-bold text-gray-900 tracking-wide">
                            {t("text_android_down")}
                        </h3>
                        <p className="text-xs sm:text-[15px] text-gray-400 mt-0.5 sm:mt-1">
                            {t("text_android_modal_subtitle")}
                        </p>
                    </div>
                </div>

                {/* Local Download Action Button */}
                <button
                    onClick={handleDownloadApk}
                    className="w-fit mt-5 sm:mt-6 flex items-center justify-center gap-2.5 py-3 sm:py-2.5 px-6 sm:px-16 bg-[#232328] hover:bg-[#19191d] text-white rounded-lg text-sm sm:text-lg font-medium tracking-wide transition-all shadow-sm active:scale-[0.99] cursor-pointer"
                >
                    <LuDownload className="text-lg sm:text-2xl" />
                    <span>{t("text_local_download")}</span>
                </button>

                {/* Risk Warning Disclaimer */}
                <div className="flex items-center gap-1.5 sm:gap-2 mt-2 sm:mt-2.5 text-gray-400">
                    <RiInformationLine className="text-sm sm:text-base shrink-0" />
                    <span className="text-[11px] sm:text-sm">
                        {t("text_android_risk_warning")}
                    </span>
                </div>

                {/* Section Divider */}
                <div className="border-t border-gray-100 my-4 sm:my-7" />

                {/* App Store Channels */}
                <div className="flex flex-col text-left">
                    <h4 className="text-xs sm:text-base font-bold text-gray-900 mb-2.5 sm:mb-4">
                        {t("text_app_stores_title")}
                    </h4>

                    {/* 3x2 Grid of QR Code Cards */}
                    <div className="grid grid-cols-3 gap-2 sm:gap-3">
                        {appStores.map((store) => (
                            <div
                                key={store.id}
                                className="border border-gray-200/90 rounded-xl sm:rounded-2xl p-2 sm:p-4 flex flex-col items-center justify-center bg-white shadow-[0_2px_8px_rgba(0,0,0,0.03)] hover:border-gray-300 transition-colors min-w-0"
                            >
                                <div className={`w-full aspect-square ${store?.nameKey === "小米应用商店"  ? "w-full aspect-square max-w-[100px] sm:max-w-[175px] h-[100px] sm:h-[90px] mx-auto p-1 sm:p-2 border border-dashed border-gray-300 rounded-lg sm:rounded-xl flex items-center justify-center bg-white overflow-hidden" : "w-full aspect-square max-w-[80px] sm:max-w-[130px] mx-auto p-1 sm:p-2 border border-dashed border-gray-300 rounded-lg sm:rounded-xl flex items-center justify-center bg-white overflow-hidden"}`}>
                                    {
                                        store?.nameKey === "小米应用商店" ? t(store?.url):
                                    <QRCode
                                        size={140}
                                        type="svg"
                                        icon={BASE_URL + "/logo1.svg"}
                                        iconSize={28}
                                        bordered={false}
                                        errorLevel="H"
                                        value={store.url || APP_ANDROID_APK_URL}
                                        style={{ width: '100%', height: '100%' }}
                                        className="w-full h-full flex items-center justify-center"
                                    />
                                    }
                                </div>
                                <span className="text-[10px] sm:text-xs md:text-sm text-gray-800 font-semibold text-center mt-1.5 sm:mt-3 whitespace-nowrap overflow-hidden text-ellipsis w-full">
                                    {t(store.nameKey)}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default forwardRef(AndroidDownloadModal);
